"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@coreui/icons");
const icons_react_1 = __importDefault(require("@coreui/icons-react"));
const react_1 = require("@coreui/react");
const react_2 = require("react");
const react_final_form_1 = require("react-final-form");
const components_1 = require("components");
const internal_portal_api_slice_1 = require("internal-portal-api-slice");
const internal_portal_components_1 = require("internal-portal-components");
const utils_1 = require("utils");
const FieldsUploads = ({ locationId, uploadCallback, isDisabled = false, }) => {
    // Hooks
    const formContext = (0, react_final_form_1.useForm)();
    const formState = (0, react_final_form_1.useFormState)();
    const fileContentType = formState.values['content'];
    const fileExpDate = formState.values['expirationDate'];
    // Hooks API
    const [postFiles] = internal_portal_api_slice_1.api.endpoints.manualPostFiles.useMutation();
    const [attachFiles] = internal_portal_api_slice_1.api.endpoints.postEnrollmentsMerchantApplicationIdFiles.useMutation();
    // State
    const [currentFileExt, setCurrentFileExt] = (0, react_2.useState)('');
    const [currentFileName, setCurrentFileName] = (0, react_2.useState)('');
    const [isEdit, setIsEdit] = (0, react_2.useState)(false);
    const [isUploading, setIsUploading] = (0, react_2.useState)(false);
    const [inputEvent, setInputEvent] = (0, react_2.useState)(null);
    const handleSubmit = (0, react_2.useCallback)(async () => {
        setIsUploading(true);
        await handleUpload(inputEvent);
        setIsUploading(false);
    }, [inputEvent]);
    const handleChange = async (evt) => {
        const tmpFile = evt.target.files && evt.target.files[0];
        if (tmpFile) {
            setInputEvent(evt);
            setCurrentFileName(String(tmpFile?.name).split('.').slice(0, -1).join('.'));
            setCurrentFileExt(getFileExt(tmpFile?.name));
        }
        else {
            setIsEdit(false);
            setInputEvent(null);
        }
    };
    const getFileExt = (tmpFile) => {
        return String(tmpFile).split('.').at(-1);
    };
    const handleUpload = async (evt) => {
        if (!evt)
            return;
        const currentFile = evt.target.files && evt.target.files[0];
        if (!currentFile)
            return;
        if (currentFile && evt.target.form instanceof HTMLFormElement) {
            const formDataInputs = new FormData(evt.target.form);
            const fileName = formDataInputs.get('fileName') ?? null;
            const validUntil = formDataInputs.get('expirationDate') ?? '';
            const merchAppId = formDataInputs.get('id');
            const fileContent = formDataInputs.get('content');
            if (!merchAppId)
                return evt;
            if (fileContent === 'medical_license') {
                const dateLength = String(validUntil).length;
                if (dateLength > 1 && dateLength < 10) {
                    (0, utils_1.toastError)(`Error uploading file: Date seems incorrect`);
                    return;
                }
                if (dateLength === 0) {
                    (0, utils_1.toastError)(`Error uploading file: Please enter a date`);
                    return;
                }
            }
            const formDataPost = new FormData();
            formDataPost.append('name', fileName
                ? `${fileName}.${getFileExt(currentFile.name)}`
                : currentFile.name);
            formDataPost.append('file', currentFile);
            formDataPost.append('comment', '');
            formDataPost.append('content', fileContent ?? '');
            if (validUntil) {
                formDataPost.append('valid_until', (0, utils_1.dateRawSplit)({
                    dateString: String(validUntil),
                }));
            }
            // Post File Upload
            const resp = await postFiles({
                body: formDataPost,
            });
            if ('error' in resp && 'data' in resp.error) {
                const errorMessage = resp.error.data.message;
                (0, utils_1.toastError)(`Error uploading file: ${errorMessage}`);
            }
            if ('data' in resp) {
                // Post File Attachments
                const resp2 = await attachFiles({
                    locationId: locationId,
                    merchantApplicationId: Number(merchAppId),
                    body: {
                        file_uuids: [resp.data.uuid],
                    },
                });
                if ('error' in resp2 && 'data' in resp2.error) {
                    const errorMessage = resp2.error.data.message;
                    (0, utils_1.toastError)(`Error attaching uploaded file: ${errorMessage}`);
                }
                // Success
                if ('data' in resp2) {
                    (0, utils_1.toastSuccess)(`Successfully uploaded file`);
                    // Reset Form
                    if (formContext) {
                        formContext.reset();
                    }
                    setIsEdit(false);
                    setInputEvent(null);
                    uploadCallback(resp2.data);
                    return true;
                }
            }
            // Fail
            return false;
        }
    };
    const handleEditCheckbox = () => {
        setIsEdit(!isEdit);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "", children: [(0, jsx_runtime_1.jsx)(internal_portal_components_1.FormSubTitle, { title: "Uploads" }), (0, jsx_runtime_1.jsxs)("fieldset", { className: isDisabled ? 'is-disabled' : '', children: [(0, jsx_runtime_1.jsxs)(react_1.CRow, { xs: { gutterY: 5 }, children: [(0, jsx_runtime_1.jsx)(react_1.CCol, { md: 6, sm: 12, children: (0, jsx_runtime_1.jsx)(components_1.InputSelectNative, { name: "content", label: 'File Content Type', altclass: "coreUI", options: [
                                            {
                                                key: 'Medical License',
                                                value: 'medical_license',
                                            },
                                            {
                                                key: 'Voided Check',
                                                value: 'voided_check',
                                            },
                                            {
                                                key: 'Other',
                                                value: 'other',
                                            },
                                        ], disabled: isDisabled }) }), (0, jsx_runtime_1.jsxs)(react_1.CCol, { md: 6, sm: 12, children: [fileContentType === 'medical_license' ? ((0, jsx_runtime_1.jsx)(internal_portal_components_1.FieldInputDate, { label: 'Expiration Date', name: 'expirationDate' })) : null, (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "id", component: 'input', type: "hidden" })] })] }), fileContentType !== '' && fileContentType ? ((0, jsx_runtime_1.jsx)(react_1.CRow, { xs: { gutterX: 5 }, children: (0, jsx_runtime_1.jsx)(react_1.CCol, { md: 12, children: isUploading ? ((0, jsx_runtime_1.jsx)(react_1.CProgress, { color: "primary", variant: "striped", animated: true, value: 25 })) : ((0, jsx_runtime_1.jsxs)(react_1.CInputGroup, { children: [isEdit && ((0, jsx_runtime_1.jsx)(react_1.CInputGroupText, { as: "label", htmlFor: "fileName", children: "Edit File" })), (0, jsx_runtime_1.jsx)(react_1.CFormInput, { id: "fileUpload", type: "file", onChange: handleChange, accept: "image/*,.pdf,.doc", className: `file-input ${isEdit ? 'display-none' : 'display-normal'}`, disabled: isDisabled }), isEdit && ((0, jsx_runtime_1.jsx)(react_1.CFormInput, { id: "fileName", name: "fileName", defaultValue: currentFileName, placeholder: "Filename", "aria-label": "Filename", "aria-describedby": "basic-addon1", disabled: isDisabled })), isEdit && ((0, jsx_runtime_1.jsx)(react_1.CInputGroupText, { children: `.${currentFileExt}` })), inputEvent && !isDisabled && ((0, jsx_runtime_1.jsx)(react_1.CInputGroupText, { id: "basic-addon1", children: (0, jsx_runtime_1.jsx)(react_1.CButton, { onClick: handleEditCheckbox, children: (0, jsx_runtime_1.jsx)(icons_react_1.default, { icon: isEdit ? icons_1.cilX : icons_1.cilPencil, size: 'sm', title: isEdit ? 'Cancel Edit' : 'Edit Filename' }) }) })), inputEvent ? ((0, jsx_runtime_1.jsx)(react_1.CButton, { onClick: handleSubmit, type: "button", color: "primary", disabled: isDisabled ||
                                                inputEvent === null ||
                                                (fileExpDate?.length < 10 &&
                                                    fileContentType === 'medical_license') ||
                                                (!fileExpDate &&
                                                    fileContentType === 'medical_license'), children: "\u00A0\u00A0\u00A0Upload\u00A0\u00A0\u00A0" })) : ((0, jsx_runtime_1.jsx)(react_1.CInputGroupText, { as: "label", htmlFor: "fileUpload", children: "Select File" }))] })) }) }, "file-upload-shown")) : ((0, jsx_runtime_1.jsx)(react_1.CRow, { xs: { gutterX: 5 }, children: (0, jsx_runtime_1.jsx)(react_1.CCol, { md: 12, children: (0, jsx_runtime_1.jsx)("div", { children: "Select a file content type to upload." }) }) }, "no-file-selected"))] })] }) }));
};
exports.default = FieldsUploads;
